import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) throw new Error('useCart debe usarse dentro de un CartProvider');
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const savedCart = localStorage.getItem('cart');
      return savedCart ? JSON.parse(savedCart) : [];
    } catch (error) { return []; }
  });

  useEffect(() => { localStorage.setItem('cart', JSON.stringify(cart)); }, [cart]);

  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.uniqueId === product.uniqueId);
      return existing 
        ? prev.map((i) => i.uniqueId === product.uniqueId ? { ...i, cantidad: i.cantidad + product.cantidad } : i)
        : [...prev, product];
    });
  };

  const removeFromCart = (id) => setCart(prev => prev.filter(i => i.uniqueId !== id));
  const clearCart = () => setCart([]);
  
  const total = cart.reduce((acc, item) => acc + item.precio * item.cantidad, 0);
  const count = cart.reduce((acc, item) => acc + item.cantidad, 0);

  // Debug: Ver si el Provider se monta
  console.log("CartProvider Activo - Items:", count);

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart, total, count }}>
      {children}
    </CartContext.Provider>
  );
};
